import { render, staticRenderFns } from "./PaymentConfirmed.vue?vue&type=template&id=a66a3c5c&scoped=true&"
import script from "./PaymentConfirmed.vue?vue&type=script&lang=ts&"
export * from "./PaymentConfirmed.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentConfirmed.vue?vue&type=style&index=0&id=a66a3c5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a66a3c5c",
  null
  
)

export default component.exports